import { useTranslation } from 'react-i18next';
import { UserCircle } from '@/design-system/icons';
import { getDaysAgo } from '@/utils/dateUtils';

interface ContactHeaderProps {
  firstName: string;
  lastName: string;
  createdAt: string;
  isManagedByCompany: boolean;
}

export function ContactHeader({
  firstName,
  lastName,
  createdAt,
  isManagedByCompany,
}: ContactHeaderProps) {
  const { t } = useTranslation();
  const daysAgo = getDaysAgo(createdAt);

  return (
    <div className="flex flex-col items-center text-center py-4">
      <div className="w-16 h-16 rounded-full bg-surface-darker flex items-center justify-center mb-3">
        <UserCircle className="w-10 h-10 text-onsurface" />
      </div>
      <h3 className="text-lg font-semibold">
        {firstName} {lastName}
      </h3>
      <p className="text-sm opacity-50 mt-1">
        {t('contact.createdDaysAgo', { count: daysAgo })}
      </p>
      {isManagedByCompany && (
        <p className="text-xs text-primary mt-1">
          {t('contact.managedByCompany')}
        </p>
      )}
    </div>
  );
}
